import { auth } from '@/firebase/auth';
import Monitoring from '@/utils/monitoring';
import { useCallback, useEffect, useState } from 'react';

export const useSignOut = () => {
  const [user, setUser] = useState(auth?.currentUser);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  const signOut = useCallback(async () => {
    try {
      // console.log("signOut call ", user);
      if (!user) {
        return;
      }

      const token = await user.getIdToken();
      await fetch('/api/auth/remove-session', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      await auth.signOut();
    } catch (error) {
      Monitoring.trackError(error as Error, {
        userId: user?.uid,
        location: 'useSignOut',
        action: 'signOut',
        hasUser: !!user,
      });
      
      throw error;
    }
  }, [user]); // Only recreate when user changes

  return signOut;
}